import pick from "lodash/pick";
import { useCallback, useContext, useEffect } from "react";
import { DecodedAccessToken } from "src/components/pages/Home/license";
import { AnalyticsContext } from "src/providers/analytics-provider";
import { useAuth } from "./useAuth";

export const useAnalyticIdentifyUser = () => {
  const { analytics } = useContext(AnalyticsContext);
  const { tokenParsed } = useAuth();

  const identifyUser = useCallback(
    (token: DecodedAccessToken | null) => {
      const currentId = analytics?.user().id();
      const { sub: id, ...user } = pick(token, [
        "license_type",
        "license_exp",
        "license_iat",
        "license_trial",
        "preferred_username",
        "email",
        "email_verified",
        "sub",
      ]);

      if (currentId === id) {
        // No change in user
        return Promise.resolve();
      }

      if (id) {
        // User updated, has id, identify
        return analytics?.identify(id, { id, ...user }, { context: { direct: true } }).catch(() => {});
      }

      // User updated, no id, unidentify (reset)
      return analytics?.reset();
    },
    [analytics],
  );

  useEffect(() => {
    if (tokenParsed && analytics?.user().id() !== tokenParsed.sub) {
      // Track changes in user
      identifyUser(tokenParsed as unknown as DecodedAccessToken);
    }
  }, [analytics, identifyUser, tokenParsed]);
};
